var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditP01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6018 18.7393H19.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.715 3.47856C12.426 2.6288 13.7042 2.5042 14.5715 3.20076C14.6195 3.23854 16.1604 4.43556 16.1604 4.43556C17.1132 5.01159 17.4093 6.23618 16.8203 7.17071C16.789 7.22075 8.07762 18.1174 8.07762 18.1174C7.78779 18.479 7.34785 18.6925 6.87767 18.6976L3.54157 18.7394L2.7899 15.558C2.68461 15.1106 2.7899 14.6408 3.07973 14.2792L11.715 3.47856Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1024 5.50079L15.1003 9.33899",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditP01);
export default __webpack_public_path__ + "static/media/edit-p01.af4d7621621525df5212fe5751bb23b4.svg";
export { ForwardRef as ReactComponent };